import axios from "axios";
import axiosRetry from "axios-retry";
import { logout } from "../../authentication/authentication";
import { appConfig } from "../../../config";

const URL = appConfig.f2fHost || "http://localhost:9060";
const BASE_URL =`${URL}api/`

// Initialize Axios Client
const axiosClient = axios.create({ baseURL: BASE_URL });

// Request Interceptors
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwtToken') || ''
  config.headers.authorization = `Bearer ${token}`;
  return config;
});

// Response Interceptors
axiosClient.interceptors.response.use(
  (response) => response,
  function (error) {
    if (error?.response?.status === 401) {
      logout()
    }
    return Promise.reject(error);
  }
);

// Configure Axios Retry
axiosRetry(axiosClient, { retries: 3 });

export default axiosClient;
